import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {ActivatedRouteSnapshot} from "@angular/router";

@Injectable({
  providedIn: 'root'
})
export class RouteService {
  public change = new Subject<ActivatedRouteSnapshot>();
  constructor(
  ) {

  }
}
